import React from 'react';
import { useDocumentInteractStart, useInteractMedia } from 'Hooks/Document';

import { InteractModalOldProps } from './common/interfaces';
import {
  InteractModalOldDesktop,
  InteractModalOldMobile,
  InteractModalOldTablet,
} from './components/Breakpoints';

function InteractModalOld(props: InteractModalOldProps) {
  const [isExtraMobile, isMedium, isTablet] = useInteractMedia(['xs', 'md', 'lg']);
  const isDocumentInteractLoading = useDocumentInteractStart(props.documentId);

  if (isExtraMobile) {
    return (
      <InteractModalOldMobile
        {...props}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  if (isMedium || isTablet) {
    return (
      <InteractModalOldTablet
        {...props}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  return (
    <InteractModalOldDesktop
      {...props}
      isDocumentInteractLoading={isDocumentInteractLoading}
    />
  );
}

export default InteractModalOld;
